export enum TagTheme {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  QUATERNARY = 'quaternary',
  QUINARY = 'quinary',
  OCTONARY = 'octonary',
  GREYED = 'greyed'
}
